import React, {Component} from 'react';
import Button from '@material-ui/core/Button';

class Whitepaper extends Component {

  render() {
    return(
      <div>
        <div class="whitepaper">
          <a class="btn btn-primary" href='http://coin.shekel.world/link.pdf' target='_blank' size="large" variant="contained" color="primary">
            <i class="material-icons">file_copy</i> <i>WHITEPAPER</i>
          </a>
        </div>
      </div>

    );
  }
}

export default Whitepaper; 
